{
  "cms.access.adminRequired": "CMS admin role required.",
  "cms.shell.notifications": "Notifications",
  "cms.shell.title": "OMA+ content management",
  "cms.error.networkOrServer": "Network or server error. Please try again shortly.",
  "cms.error.publishFailedReconcileNeeded": "Publish failed but the content may still be published. Check the catalog for the current state.",
  "cms.error.staleDraft": "A newer version of this draft has been saved. Load the current draft to continue.",
  "cms.error.staleDraft.reload": "Reload current draft",
  "cms.error.unknownShape": "Unknown content shape.",
  "cms.status.draft": "Draft",
  "cms.status.published": "Published",
  "cms.aloitus.scheduled.empty": "No scheduled content.",
  "cms.aloitus.scheduled.title": "Scheduled content",
  "cms.sivupohjat.placeholder": "Page templates will be added later.",
  "cms.topBar.action.goToPublicPage": "Open public page",
  "cms.topBar.label": "Content actions"
}
